import axios from 'axios';
export { CertificateTrackAction, TrackCategory, PageTrackAction, } from './legacy-model.js';
export const track = async (root, event) => axios.post(`${root}/legacy/activity-metric/track`, event);
//# sourceMappingURL=activity-metric.js.map